@if (selectedItemsArray?.length >= 1) {
<div class="checklist-floater-action-container modal-footter"
[ngClass]="{'right-[228px] bottom-[46px]': isFromMXFinancialAccount}"
>
  <div class="checklist-floater-action-container-body">
    <div class="checklist-floater-item-container">
      @if(!isFromMXFinancialAccount){
      <div class="checklist-floater-item-container-left workspace-left">
        <h1 class="checklist-floater-item-container-left-title">{{ selectedItemsArray?.length }}</h1>
        <p class="checklist-floater-item-container-left-text">
          Selected
        </p>
      </div>
      }
      @if(isFromMXFinancialAccount){
      <div class="checklist-floater-item-container-left mx-financial-account-left">
        <h1 class="checklist-floater-item-container-left-title text-2xl font-bold font-open-sans h-[36px] pt-0">{{ selectedItemsArray?.length }}</h1>
        <p class="checklist-floater-item-container-left-text text-base font-bold font-open-sans m-0">
          Selected
        </p>
      </div>
      }
      <div class="workspace-right-wrapper">
        @if(isSharedFiles){
        <div class="checklist-floater-item-container-body" (click)="unShareFile()" role="button" aria-label="Delete checklist">
          <img src="assets/images/unshare-all-files.svg" style="height: 36px" />
          <p class="checklist-floater-item-container-body-text" style="color: #eb5757 !important">Unshare</p>
        </div>

        }@else{ @if(!isFromMXFinancialAccount && isDownloadableFilesOnly){
        <div class="checklist-floater-item-container-body" (click)="downloadChecklist()" matRipple role="button" aria-label="Download checklist">
          <span class="material-icons checklist-floater-item-container-body-icon">download</span>
          <p class="checklist-floater-item-container-body-text">Download</p>
        </div>

      }
      <div class="checklist-floater-item-container-body" (click)="shareChecklist()" matRipple role="button" aria-label="Share checklist">
        <span class="material-icons checklist-floater-item-container-body-icon">share</span>
        <p class="checklist-floater-item-container-body-text">Share</p>
      </div>
        @if(!isFromMXFinancialAccount){
        <div
          class="checklist-floater-item-container-body"
          [matMenuTriggerFor]="statusMenu"
          matRipple
          role="button"
          aria-label="checklist status"
          (click)="handleStatusMenu($event)"
        >
          <img src="assets/images/progress-indicator.svg" />
          <p class="checklist-floater-item-container-body-text">Status</p>
        </div>

        <mat-menu
          #statusMenu="matMenu"
          yPosition="above"
          xPosition="before"
          class="popup-menu-panel popup-menu-panel-status statusMenu app__mat-menu-panel"
          id="statusMenu"
          style="padding: 0 20px"
        >
          @for (status of templateStatuses; track status) {
          <button
            [ngClass]="getStatusMenuItemClass(status.status)"
            mat-menu-item
            class="popup-menu-item text-sm font-bold flex items-center justify-center cursor-pointer"
            (click)="handleStatusChange(status)"
          >
            {{ status.type }}
          </button>
          }
        </mat-menu>
        }
        @if(!isFromMXFinancialAccount){
        <div class="checklist-floater-item-container-body" (click)="duplicateTemplate()" matRipple role="button" aria-label="Duplicate template">
          <span class="material-icons checklist-floater-item-container-body-icon">content_copy</span>
          <p class="checklist-floater-item-container-body-text">Duplicate</p>
        </div>
        }
        @if(!isFromMXFinancialAccount){
        <div class="checklist-floater-item-container-body" (click)="move()" matRipple role="button" aria-label="Move items">
          <span class="material-icons checklist-floater-item-container-body-icon">low_priority</span>
          <p class="checklist-floater-item-container-body-text">Move {{ isFromMXFinancialAccount ? 'to' : '' }}</p>
        </div>
        }
        @if(isFromMXFinancialAccount){
          <div class="checklist-floater-item-container-body" (click)="notInUse()" matRipple role="button" aria-label="Move items">
            <span class="material-icons checklist-floater-item-container-body-icon text-[#EB5757]">remove_circle_outline</span>
            <p class="checklist-floater-item-container-body-text text-[#EB5757] text-base font-bold font-open-sans m-0">Not In Use</p>
          </div>
        }
        @if(!isFromMXFinancialAccount){
        <div class="checklist-floater-item-container-body" (click)="deleteChecklist()" role="button" aria-label="Delete checklist">
          <img src="assets/images/trash-2.svg" style="height: 36px" />
          <p class="checklist-floater-item-container-body-text" style="color: #eb5757 !important">Delete</p>
        </div>
        } }
        @if(isFromMXFinancialAccount){
        <div class="checklist-floater-item-container-right" (click)="clearSelection()" role="button" aria-label="Close selection">
          <span class="checklist-floater-item-container-right-line"></span>
          <span class="material-icons checklist-floater-item-container-right-closeicon">
            clear</span
          >
          <p class="checklist-floater-item-container-right-closetext text-base font-bold font-open-sans m-0">Close</p>
        </div>
      }
      @if(!isFromMXFinancialAccount){
        <div class="checklist-floater-item-container-right" (click)="clearSelection()" role="button" aria-label="Close selection">
          <span class="material-icons checklist-floater-item-container-right-closeicon" [ngClass]="{ 'text-k-blue': isFromMXFinancialAccount }">
            clear</span
          >
          <p class="checklist-floater-item-container-right-closetext" [ngClass]="{ 'text-k-blue': isFromMXFinancialAccount }">Close</p>
        </div>
      }
      </div>
    </div>
  </div>
</div>
}
